module.exports = __webpack_public_path__ + "static/media/pause_resume.ed1c74a6.gif";